import type { ReportData } from '@/types/report';

export const cloneReportData = (data: ReportData): ReportData => {
    if (typeof structuredClone === 'function') {
        return structuredClone(data);
    }

    return JSON.parse(JSON.stringify(data)) as ReportData;
};
